
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b468152753 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1087353103 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1400585691 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b365449300 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b2078342333 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.a377667727 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2091708005 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1743402256 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b531968919 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1697727624 = messageFormatterFn((function(  ) {
  return function(d) { return "Đây là thiết bị công cộng/dùng chung"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b265687743 = messageFormatterFn((function(  ) {
  return function(d) { return "Không phải thiết bị của bạn? Chọn ô này sẽ rút ngắn thời gian đăng xuất tự động sau khi bạn không hoạt động."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1680900892 = messageFormatterFn((function(  ) {
  return function(d) { return "Giữ tôi luôn đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1313121086 = messageFormatterFn((function(  ) {
  return function(d) { return "Chọn ô này sẽ giữ bạn đăng nhập trên thiết bị này đến khi chọn thoát. Đừng chọn ô này nếu dùng chung thiết bị với người khác."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1757571738 = messageFormatterFn((function(  ) {
  return function(d) { return "Quên mật khẩu?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1268085365 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1250418552 = messageFormatterFn((function(  ) {
  return function(d) { return "Hủy"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1740081215 = messageFormatterFn((function(  ) {
  return function(d) { return "Quay lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b709455549 = messageFormatterFn((function(  ) {
  return function(d) { return "Tải lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1221560584 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc đăng nhập, tôi đồng ý với <a href=" + d["1"] + " " + d["3"] + ">Điều khoản & Điều kiện</a> và <a href=" + d["2"] + " " + d["4"] + ">Tuyên bố Bảo mật</a> của " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1668402086 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc đăng nhập, tôi đồng ý với <a href=" + d["1"] + " " + d["5"] + ">Điều khoản & Điều kiện</a>, <a href=" + d["2"] + " " + d["6"] + ">Tuyên bố bảo mật</a> của " + d["0"] + " và <a href=" + d["3"] + " " + d["7"] + ">Điều khoản & Điều kiện " + d["4"] + "</a>."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a160640126 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc đăng nhập, tôi cũng đồng thời tham gia " + d["4"] + ". Tôi đồng ý với <a href=" + d["1"] + " " + d["5"] + ">Điều khoản & Điều kiện</a>, <a href=" + d["2"] + " " + d["6"] + ">Tuyên bố bảo mật</a> của " + d["0"] + " và <a href=" + d["3"] + " " + d["7"] + ">Điều khoản & Điều kiện " + d["4"] + "</a>."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a274539603 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi tạm ngưng tài khoản của bạn để kiểm tra bảo mật định kỳ. Thông tin của bạn vẫn an toàn nhưng bạn cần đặt lại mật khẩu. Để đăng nhập, hãy đổi mật khẩu bằng liên kết \"Quên mật khẩu?\" dưới đây."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1447541815 = messageFormatterFn((function(  ) {
  return function(d) { return "Email và mật khẩu không khớp. Vui lòng thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a233965764 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, chúng tôi đang gặp trục trặc."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b571619254 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, chúng tôi đang gặp trục trặc. Vui lòng đợi trong giây lát và thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1769634456 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập địa chỉ email."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a367645945 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy nhập email hợp lệ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a847379937 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b560298485 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang kiểm tra thông tin đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b197113766 = messageFormatterFn((function(  ) {
  return function(d) { return "Ẩn mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a117228373 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiển thị mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1395540809 = messageFormatterFn((function(  ) {
  return function(d) { return "Chưa có tài khoản? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Tạo tài khoản</a></span>"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a348861070 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a869877595 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập qua " + d["0"] + " không còn là tùy chọn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1293956609 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn có thể sử dụng cùng một email để truy cập vào tài khoản " + d["0"] + " của mình bằng cách thiết lập lại mật khẩu. Việc này sẽ không ảnh hưởng đến tài khoản " + d["1"] + " của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1379391853 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập lại mật khẩu bằng nút bên dưới. Lần tới, hãy sử dụng email và mật khẩu mới để đăng nhập trực tiếp vào " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b202201370 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập SSO"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a789910702 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng tính năng đăng nhập một lần"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1516897530 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoặc sử dụng tài khoản " + d["0"] + " của bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a31210809 = messageFormatterFn((function(  ) {
  return function(d) { return "Tích lũy điểm để đổi sản phẩm du lịch miễn phí. Tiết kiệm với giá thành viên. Truy cập lịch trình dễ dàng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1363850925 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhận " + d["0"] + " điểm Expedia Rewards sau khi kết thúc chuyến đi này."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1239599024 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập tài khoản " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1182291794 = messageFormatterFn((function(  ) {
  return function(d) { return "Quên mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1865915401 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập lại mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2134682877 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập địa chỉ email và chúng tôi sẽ gửi link thiết lập lại mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1179648689 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi link thiết lập lại mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1485406004 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy kiểm tra hộp thư"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2101459236 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi đã gửi email với link thiết lập lại mật khẩu của bạn đến " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2101458275 = messageFormatterFn((function(  ) {
  return function(d) { return "Có thể mất vài phút để nhận được email. Nếu vẫn không thấy email sau hơn 10 phút, hãy kiểm tra hộp thư rác (junk hoặc spam)."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a971652441 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi lại link"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1223059969 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã gửi link mới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1251646254 = messageFormatterFn((function(  ) {
  return function(d) { return "Xác thực tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b500254034 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a962546185 = messageFormatterFn((function(  ) {
  return function(d) { return "Chào mừng bạn quay lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2127445757 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy tạo một mật khẩu riêng biệt để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1072509912 = messageFormatterFn((function(  ) {
  return function(d) { return "Thành công!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1386978277 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiện tại bạn đã có thể sử dụng trang web với mật khẩu mới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a213330112 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập lại mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a98465789 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, yêu cầu này đã hết hạn. Nếu vẫn cần thay đổi mật khẩu, vui lòng bấm vào dưới đây để gửi email thiết lập lại mật khẩu mới."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b944793523 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi lại link"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1156627064 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang lưu mật khẩu của bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b576237932 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1661044824 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1483798381 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1167557643 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập địa chỉ email."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1398005028 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy nhập email hợp lệ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1694238670 = messageFormatterFn((function(  ) {
  return function(d) { return "Tên"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1057884246 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập tên."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1535555948 = messageFormatterFn((function(  ) {
  return function(d) { return "Họ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b660673804 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập họ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a394249581 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập tên chỉ gồm chữ cái"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1909028890 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a189708654 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1544790787 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng nhập mật khẩu hợp lệ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b623731741 = messageFormatterFn((function(  ) {
  return function(d) { return "Bao gồm từ 9-64 ký tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b623730780 = messageFormatterFn((function(  ) {
  return function(d) { return "Gồm chữ cái và số"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b623729819 = messageFormatterFn((function(  ) {
  return function(d) { return "Một ký tự đặc biệt ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b623728858 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu không được có khoảng trắng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b186196045 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu phải gồm từ 8-64 ký tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1887146208 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu phải khác địa chỉ email."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1729089501 = messageFormatterFn((function(  ) {
  return function(d) { return "Mật khẩu không được có khoảng trắng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b408518187 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc tạo tài khoản, tôi đồng ý với <a href=" + d["1"] + " " + d["3"] + ">Điều khoản & Điều kiện</a> và <a href=" + d["2"] + " " + d["4"] + ">Tuyên bố Bảo mật</a> của " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a56930477 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc tạo tài khoản, tôi đồng ý với <a href=" + d["1"] + " " + d["5"] + ">Điều khoản & Điều kiện</a>, <a href=" + d["2"] + " " + d["6"] + ">Tuyên bố bảo mật</a> của " + d["0"] + " và <a href=" + d["3"] + " " + d["7"] + ">Điều khoản & Điều kiện " + d["4"] + "</a>."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1299118194 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi muốn nhận email về các ưu đãi du lịch, khuyến mãi đặc biệt hoặc các thông tin khác từ " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b49032799 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi muốn nhận email về các ưu đãi du lịch, khuyến mãi đặc biệt hoặc các thông tin khác từ " + d["0"] + ". Bạn có thể chọn ngưng nhận email khuyến mãi bất kỳ lúc nào."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a395063377 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi muốn nhận email về những ý tưởng cho các kỳ nghỉ, khuyến mãi đặc biệt hoặc các thông tin khác từ " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2070560190 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi muốn nhận email về những ý tưởng cho các kỳ nghỉ, khuyến mãi đặc biệt hoặc các thông tin khác từ " + d["0"] + ". Bạn có thể chọn ngưng nhận email khuyến mãi bất kỳ lúc nào."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b108974606 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1538720481 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã có tài khoản? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Đăng nhập</a></span>"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a615076924 = messageFormatterFn((function(  ) {
  return function(d) { return "Chào " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1196875126 = messageFormatterFn((function(  ) {
  return function(d) { return "Với tài khoản " + d["0"] + " mới, thế giới nằm trong tầm tay."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1974779693 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b308943778 = messageFormatterFn((function(  ) {
  return function(d) { return "Cần mật khẩu có hiệu quả bảo mật mạnh hơn để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b742355805 = messageFormatterFn((function(  ) {
  return function(d) { return "Phải gồm tối thiểu 8 ký tự."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a442439239 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiệu quả bảo mật"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b221328613 = messageFormatterFn((function(  ) {
  return function(d) { return "Yếu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a295611514 = messageFormatterFn((function(  ) {
  return function(d) { return "Mạnh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b31403056 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất mạnh"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1480217493 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh những ký tự thay thế dễ đoán như '@' thay cho 'a'."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b77755331 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh viết ngược những từ thông dụng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1118364955 = messageFormatterFn((function(  ) {
  return function(d) { return "Viết hoa một vài nhưng không phải tất cả ký tự."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a946739004 = messageFormatterFn((function(  ) {
  return function(d) { return "Viết hoa không chỉ ký tự đầu tiên."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1572453152 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh ngày tháng năm liên quan đến thông tin cá nhân của bản thân."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1092542122 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh những năm gần đây."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1167449039 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh năm liên quan đến thông tin cá nhân của bản thân."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1792682340 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh những kết hợp ký tự thông dụng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b728979978 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh từ và ký tự lặp lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a351931610 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng kiểu gõ bàn phím dài hơn và thay đổi hướng gõ nhiều lần."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b405021953 = messageFormatterFn((function(  ) {
  return function(d) { return "Thêm từ ít thông dụng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b363090645 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng nhiều từ nhưng tránh những cụm từ thường đi với nhau."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a43419214 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn vẫn có thể tạo mật khẩu mạnh mà không cần dùng đến ký hiệu, số hay chữ viết hoa."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a420788309 = messageFormatterFn((function(  ) {
  return function(d) { return "Địa chỉ email này đã được liên kết với một tài khoản trên " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1939308839 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi đã gửi đường link để bạn hoàn tất tạo tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b250463480 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang xử lý yêu cầu đăng nhập"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1290521868 = messageFormatterFn((function(  ) {
  return function(d) { return "Tên phải gồm tối thiểu 2 ký tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1723971206 = messageFormatterFn((function(  ) {
  return function(d) { return "Họ phải gồm tối thiểu 2 ký tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b42472030 = messageFormatterFn((function(  ) {
  return function(d) { return "Tên chỉ có thể gồm tối đa 100 ký tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b475921368 = messageFormatterFn((function(  ) {
  return function(d) { return "Họ chỉ có thể gồm tối đa 100 ký tự"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1739205603 = messageFormatterFn((function(  ) {
  return function(d) { return "Tên không được có ký tự đặc biệt"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1672191709 = messageFormatterFn((function(  ) {
  return function(d) { return "Họ không được có ký tự đặc biệt"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b502592325 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi đồng ý với tất cả những điều dưới đây"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a880278407 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi xác nhận rằng tôi từ 18 tuổi trở lên, tôi đã xem xét và đồng ý với <a href=" + d["0"] + " " + d["1"] + ">Điều khoản sử dụng</a> và <a href=" + d["2"] + " " + d["3"] + ">Điều khoản & điều kiện của " + d["4"] + "</a> (bắt buộc)*"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1923133979 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi cho phép thu thập và sử dụng thông tin cá nhân của mình như mô tả trong <a href=" + d["0"] + " " + d["1"] + ">Chính sách bảo mật</a> (bắt buộc)"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1616241618 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi cho phép cung cấp thông tin cá nhân của mình cho các bên thứ ba, ở Hàn Quốc hoặc nước ngoài, như mô tả trong <a href=" + d["0"] + " " + d["1"] + ">Chính sách bảo mật</a> (bắt buộc)"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1918375217 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng chấp nhận các điều khoản để tiếp tục."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1466886517 = messageFormatterFn((function(  ) {
  return function(d) { return "Chấp nhận Điều khoản để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1893639239 = messageFormatterFn((function(  ) {
  return function(d) { return "Đánh dấu chọn ô để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a674206400 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoặc tạo tài khoản " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a992050046 = messageFormatterFn((function(  ) {
  return function(d) { return "Tránh sử dụng khoảng trắng, tên, email hoặc mật khẩu bạn đã từng dùng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a223414174 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, đã có lỗi. Vui lòng đợi trong giây lát rồi thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a795324420 = messageFormatterFn((function(  ) {
  return function(d) { return "Xác thực số điện thoại di động"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a445391093 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi sẽ gửi mã xác thực 1 lần đến số điện thoại di động này nhằm đảm bảo an toàn cho tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a934976018 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1889098613 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + ". Mọi quyền được bảo lưu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a409716419 = messageFormatterFn((function(  ) {
  return function(d) { return "Điều khoản và Điều kiện"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b732526524 = messageFormatterFn((function(  ) {
  return function(d) { return "Chính sách Bảo mật"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1292597243 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi tôi tin nhắn SMS"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2068978896 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập mã xác thực"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1170272418 = messageFormatterFn((function(  ) {
  return function(d) { return "Mã xác thực"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1005761237 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi lại mã"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1669467286 = messageFormatterFn((function(  ) {
  return function(d) { return "Thay đổi số điện thoại di động"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b242155810 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã gửi mã xác thực."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1531383575 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy nhập mã xác thực gồm 6 chữ số chúng tôi vừa gửi đến " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b911918588 = messageFormatterFn((function(  ) {
  return function(d) { return "Đang kiểm tra mã xác thực"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a720504707 = messageFormatterFn((function(  ) {
  return function(d) { return "Mã này không chính xác. Gửi lại mã để thử lần nữa."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b814429661 = messageFormatterFn((function(  ) {
  return function(d) { return "hoặc tiếp tục bằng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1570641869 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiết kiệm trung bình " + d["0"] + "% tại hàng ngàn khách sạn khi là thành viên. Hoàn toàn miễn phí!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a997822401 = messageFormatterFn((function(  ) {
  return function(d) { return "hoặc"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b836652289 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng cách khác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b836292875 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng ký bằng cách khác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a140445237 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng ký bằng Google"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1483230100 = messageFormatterFn((function(  ) {
  return function(d) { return "Không đăng nhập được. Hãy thử lại hoặc tạo tài khoản trên trang này để tiếp tục."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1656732814 = messageFormatterFn((function(  ) {
  return function(d) { return "Không thể đăng nhập bằng số điện thoại. Hãy đảm bảo rằng tài khoản mạng xã hội của bạn cho phép chia sẻ email."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1979706490 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiết kiệm " + d["0"] + "% trở lên tại hàng ngàn khách sạn khi là thành viên. Hoàn toàn miễn phí!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2101666411 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng Google"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1048424768 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng NAVER"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a634862538 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã quá số lần thử đăng nhập tối đa. Hãy thử lại sau."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b679370403 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng dữ liệu sinh trắc học"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b516620637 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng dữ liệu sinh trắc học để truy cập vào tài khoản và không còn cần phải nhập mật khẩu nữa."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1654734928 = messageFormatterFn((function(  ) {
  return function(d) { return "Bắt đầu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a718459360 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhắc tôi sau"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1311178602 = messageFormatterFn((function(  ) {
  return function(d) { return "Thành công!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a335761360 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã bật chế độ đăng nhập bằng dữ liệu sinh trắc học."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2091434760 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập bằng dữ liệu sinh trắc học"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2100578173 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a240088568 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng dữ liệu sinh trắc học"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b982199473 = messageFormatterFn((function(  ) {
  return function(d) { return "Cập nhật mật khẩu của bạn để tiếp tục"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b577170419 = messageFormatterFn((function(  ) {
  return function(d) { return "Để truy cập vào tài khoản, bạn cần cài đặt lại mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a527833821 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập lại mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b162253053 = messageFormatterFn((function(  ) {
  return function(d) { return "Ưu đãi chào mừng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b763962647 = messageFormatterFn((function(  ) {
  return function(d) { return "Bắt đầu chuyến phiêu lưu kế tiếp với một phần quà trị giá $" + d["0"] + " ở dạng điểm từ chúng tôi!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1784771737 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn có thể thấy phần quà này ngay lập tức trong tài khoản cũng như sử dụng ngay trong lần đặt chỗ đầu tiên. Bạn chỉ cần tìm tuỳ chọn sử dụng điểm khi thanh toán."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a68625493 = messageFormatterFn((function(  ) {
  return function(d) { return "Giờ đây bạn đã là thành viên Expedia."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1744343173 = messageFormatterFn((function(  ) {
  return function(d) { return "Bắt đầu tiết kiệm ngay lập tức với giá thành viên và nhận điểm thưởng khi bạn đặt phòng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1929169776 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập hoặc tạo tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b807126678 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiết kiệm trung bình " + d["0"] + "% tại hàng ngàn khách sạn khi là thành viên. Hoàn toàn miễn phí!"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a511127576 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc tiếp tục, bạn đã đọc và đồng ý với <a href=" + d["1"] + " " + d["3"] + ">Điều khoản & Điều kiện</a> và <a href=" + d["2"] + " " + d["4"] + ">Tuyên bố bảo mật</a> của chúng tôi."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a984254282 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc tiếp tục, bạn đã đọc và đồng ý với <a href=" + d["1"] + " " + d["5"] + ">Điều khoản & Điều kiện</a>, <a href=" + d["2"] + " " + d["6"] + ">Tuyên bố bảo mật</a> của chúng tôi và <a href=" + d["3"] + " " + d["7"] + ">Điều khoản & Điều kiện của " + d["4"] + "</a>."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1584147355 = messageFormatterFn((function(  ) {
  return function(d) { return "Bằng việc tiếp tục, bạn đã đọc và đồng ý với <a href=" + d["1"] + " " + d["4"] + ">Điều khoản & Điều kiện</a>, <a href=" + d["2"] + " " + d["5"] + ">Tuyên bố bảo mật</a> của chúng tôi và <a href=" + d["3"] + " " + d["6"] + ">Điều khoản & Điều kiện của chương trình khách hàng thân thiết One Key</a>."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a333033119 = messageFormatterFn((function(  ) {
  return function(d) { return "Email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a516706329 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy nhập email hợp lệ"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2055788764 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1829524439 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a589974509 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1785606426 = messageFormatterFn((function(  ) {
  return function(d) { return "Tùy chọn này chỉ dành cho thiết bị cá nhân. Đừng chọn nếu đây là thiết bị công cộng/dùng chung để đảm bảo an toàn cho tài khoản của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2133265623 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã cố đăng nhập quá nhiều lần. Bạn cần đợi " + d["0"] + " phút mới có thể thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1048551781 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã cố đăng nhập quá nhiều lần. Ban cần đợi " + d["0"] + " phút mới có thể thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1043656447 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã cố đăng nhập quá nhiều lần. Bạn cần đợi " + d["0"] + " phút mới có thể thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1057114291 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã cố đăng nhập quá nhiều lần. Bạn cần đợi " + d["0"] + " phút mới có thể thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1785719072 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã cố đăng nhập quá nhiều lần. Bạn cần đợi " + d["0"] + " phút mới có thể thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1835615813 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn đã cố đăng nhập quá nhiều lần. Bạn cần đợi " + d["0"] + " phút mới có thể thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1346598156 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng một tài khoản để nhận thưởng trên cả Expedia, Hotels.com và Vrbo."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2002626500 = messageFormatterFn((function(  ) {
  return function(d) { return "Sử dụng một tài khoản để khám phá thế giới trên cả Expedia, Hotels.com và Vrbo."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a657586379 = messageFormatterFn((function(  ) {
  return function(d) { return "Xem và lưu nơi lưu trú, lên kế hoạch cùng cả nhóm và truy cập chi tiết đặt phòng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b324665782 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi tạm ngưng tài khoản của bạn để kiểm tra bảo mật định kỳ. Thông tin của bạn vẫn an toàn nhưng bạn cần đặt lại mật khẩu."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b642945050 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập và đặt kỳ lưu trú để nhận OneKeyCash"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1476090194 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy xác nhận đó là bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a220638572 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy nhập mã bảo mật chúng tôi đã gửi qua email. Nếu không thấy email này trong hộp thư đến, hãy kiểm tra hộp thư rác."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1158342528 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy xác nhận email của bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a133435994 = messageFormatterFn((function(  ) {
  return function(d) { return "Để tiếp tục, hãy nhập mã bảo mật chúng tôi đã gửi đến " + d["0"] + ". Nếu không thấy email này trong hộp thư đến, hãy kiểm tra hộp thư rác."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1784159468 = messageFormatterFn((function(  ) {
  return function(d) { return "Mã bảo mật 6 chữ số"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1873852524 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi lại mã"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a268540355 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a559165429 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi lại mã sau " + d["0"] + " giây"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b316140795 = messageFormatterFn((function(  ) {
  return function(d) { return "Không nhận được email?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1023123427 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn có thể yêu cầu gửi mã khác sau " + d["0"] + " giây"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b689191898 = messageFormatterFn((function(  ) {
  return function(d) { return "Yêu cầu gửi mã bảo mật khác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a441334192 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi sẽ gửi mã bảo mật mới gồm 6 chữ số vào hộp thư đến của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1321128571 = messageFormatterFn((function(  ) {
  return function(d) { return "Xác nhận bằng mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b548798938 = messageFormatterFn((function(  ) {
  return function(d) { return "Mã không hợp lệ, vui lòng thử lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1657297580 = messageFormatterFn((function(  ) {
  return function(d) { return "Mã đã hết hạn, vui lòng gửi lại rồi thử lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1673229129 = messageFormatterFn((function(  ) {
  return function(d) { return "Nếu không thấy email này trong hộp thư đến, hãy kiểm tra hộp thư rác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1580587504 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi vừa cập nhật trải nghiệm và cần xác nhận email của bạn. Hãy nhập mã bảo mật bạn nhận được trong hộp thư đến."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a117288719 = messageFormatterFn((function(  ) {
  return function(d) { return "Hệ thống vừa có trục trặc. Vui lòng thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a516465880 = messageFormatterFn((function(  ) {
  return function(d) { return "Để cập nhật phương thức đăng nhập, hãy nhập mã bảo mật chúng tôi đã gửi qua email."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1489013166 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhập mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1728224793 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi mã bảo mật qua email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1164005991 = messageFormatterFn((function(  ) {
  return function(d) { return "Email và mật khẩu không khớp"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1914414750 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a420973260 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1836651378 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn có thể sử dụng cùng email và mật khẩu để đăng nhập Expedia, Hotels.com và Vrbo."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1909400110 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1185479947 = messageFormatterFn((function(  ) {
  return function(d) { return "Thiết lập mật khẩu để sử dụng ngoài các phương thức đăng nhập bảo mật khác."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1086207424 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo mật khẩu mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1759263786 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo mật khẩu mới"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1289967216 = messageFormatterFn((function(  ) {
  return function(d) { return "Giờ bạn có thể sử dụng một tài khoản duy nhất để đăng nhập Expedia, Hotels.com và Vrbo. Tạo mật khẩu bảo mật mới cho tài khoản kết hợp của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1770614608 = messageFormatterFn((function(  ) {
  return function(d) { return "Tạo mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1457266616 = messageFormatterFn((function(  ) {
  return function(d) { return "Đổi mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1044098040 = messageFormatterFn((function(  ) {
  return function(d) { return "Dùng một mật khẩu an toàn và duy nhất."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a754970152 = messageFormatterFn((function(  ) {
  return function(d) { return "Cập nhật mật khẩu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1469519765 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi không thể thay đổi mật khẩu của bạn. Vui lòng thử lại."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b414742541 = messageFormatterFn((function(  ) {
  return function(d) { return "Quên mật khẩu?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b720664057 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy nhập email của bạn. Chúng tôi sẽ gửi mã bảo mật để bạn đăng nhập."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1422008761 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi email"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a465038469 = messageFormatterFn((function(  ) {
  return function(d) { return "Liên hệ với chúng tôi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2109293322 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa dữ liệu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a118818239 = messageFormatterFn((function(  ) {
  return function(d) { return "Đóng"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1660983395 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng chờ trong khi chúng tôi kiểm tra tài khoản của bạn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1394935420 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1050427936 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã hiểu"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1705167204 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, bạn không thể xóa tài khoản cho đến khi chuyến đi kết thúc."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b281676027 = messageFormatterFn((function(  ) {
  return function(d) { return "Để đảm bảo chuyến đi suôn sẻ, bạn sẽ cần có tài khoản để xem thông tin đặt phòng và nhận trợ giúp từ bộ phận chăm sóc khách hàng trong trường hợp có thay đổi vào phút chót."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a319869998 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, trước tiên bạn cần xóa tài khoản chủ nhà Vrbo của mình"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1361449225 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng truy cập Trung tâm hỗ trợ trên trang web hoặc app để trực tiếp liên hệ với bộ phận chăm sóc khách hàng của chúng tôi và bắt đầu quy trình."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b796332359 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy thử lại sau khi chuyến đi kết thúc."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1265091114 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy cho chúng tôi biết lý do bạn xoá tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b445262215 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi nhận được quá nhiều email và thông báo"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1012724209 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi sử dụng tài khoản " + d["0"] + " khác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1483279478 = messageFormatterFn((function(  ) {
  return function(d) { return "Chuyến đi của tôi đã kết thúc nên tôi không cần tài khoản này nữa"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b157322416 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi có trải nghiệm đặt phòng không tốt với " + d["0"]; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1955505329 = messageFormatterFn((function(  ) {
  return function(d) { return "Khác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1748217970 = messageFormatterFn((function(  ) {
  return function(d) { return "Bỏ qua"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1525408917 = messageFormatterFn((function(  ) {
  return function(d) { return "Gửi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1172535589 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc vì bạn quyết định rời đi. Sau đây là một số thông tin bạn cần biết:"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a447296904 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " điểm Expedia Rewards trị giá " + d["1"] + ", khoản tín thác trị giá " + d["2"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b53174615 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " điểm Expedia Rewards trị giá " + d["1"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a449042539 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất danh mục du lịch, khoản hoàn tiền và các tùy chọn."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1249414753 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: Bạn sẽ mất " + d["0"] + " đêm thưởng trị giá " + d["1"] + " và " + d["2"] + " tem với giá trị trung bình là " + d["3"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a686754098 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất các khoản hoàn tiền, coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b917753638 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " CheapCash trị giá " + d["1"] + ", khoản tín thác trị giá " + d["2"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b654459881 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " CheapCash trị giá " + d["1"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1579656622 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " Orbuck trị giá " + d["1"] + ", khoản tín thác trị giá " + d["2"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2142467999 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " Orbuck trị giá " + d["1"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1644985608 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + "MrJet Rewards trị giá " + d["1"] + ", khoản tín thác trị giá " + d["2"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1732355881 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " MrJet Rewards trị giá " + d["1"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a830179066 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " BONUS+ trị giá " + d["1"] + ", khoản tín thác trị giá " + d["2"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1899057655 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất " + d["0"] + " BONUS+ trị giá " + d["1"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1416665724 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2008032153 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất khoản tín thác trị giá " + d["0"] + ", coupon, sản phẩm chuyến đi đã lưu và tùy chọn tài khoản."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a306990077 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi có thể lưu giữ bảo mật một số thông tin, như thông tin lưu trữ về các giao dịch của bạn, để hoàn thành nghĩa vụ pháp lý hoặc trong trường hợp chúng tôi cần đưa ra, thực hiện hoặc bảo vệ khiếu nại pháp lý. Thông tin này sẽ được lưu giữ bảo mật và sẽ bị xóa, ẩn danh hoặc che giấu vĩnh viễn khi không còn cần thiết."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1805581199 = messageFormatterFn((function(  ) {
  return function(d) { return "Xóa tài khoản vĩnh viễn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a880583873 = messageFormatterFn((function(  ) {
  return function(d) { return "Không xóa tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1883874889 = messageFormatterFn((function(  ) {
  return function(d) { return "Chúng tôi mong được gặp lại bạn"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b492388712 = messageFormatterFn((function(  ) {
  return function(d) { return "Có thể sẽ mất vài tuần để xử lý yêu cầu xóa của bạn, vì vậy bạn có thể tiếp tục nhận thông báo trong khi hệ thống của chúng tôi cập nhật."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1589063246 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng thử lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1772789457 = messageFormatterFn((function(  ) {
  return function(d) { return "Có lỗi hệ thống phát sinh. Hãy gửi lại yêu cầu xóa tài khoản hoặc thử lại sau vài phút."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a260941239 = messageFormatterFn((function(  ) {
  return function(d) { return "Bỏ qua"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1266570032 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sử dụng tên gì trên giấy tờ tùy thân dùng khi đi lại?"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2092547072 = messageFormatterFn((function(  ) {
  return function(d) { return "Tên tài khoản của bạn phải giống với tên trên giấy tờ tùy thân bạn dùng khi đi lại, như hộ chiếu. Chúng tôi sẽ điền sẵn vào lần tới khi bạn đặt."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1538394258 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhận email về các ưu đãi, khuyến mãi và thông tin khác từ " + d["0"] + "."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1847832001 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhận email về các ưu đãi, khuyến mãi và thông tin khác từ " + d["0"] + ". Bạn có thể chọn không nhận email tiếp thị bất cứ lúc nào."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b633285252 = messageFormatterFn((function(  ) {
  return function(d) { return "Thông tin tài khoản"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b868819502 = messageFormatterFn((function(  ) {
  return function(d) { return "Nhận email về ưu đãi, khuyến mãi và thông tin khác từ " + d["0"] + ". Bạn có thể chọn ngừng nhận bất cứ lúc nào."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1143313710 = messageFormatterFn((function(  ) {
  return function(d) { return "Luôn cập nhật thông tin"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a825026936 = messageFormatterFn((function(  ) {
  return function(d) { return "Cho phép tiếp thị"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1405356039 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1658590651 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1964393485 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a465241179 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b999824569 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a864677890 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1816573066 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b355793801 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, bạn cần đợi đến sau khi hoàn tất chuyến đi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b492528583 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, bạn cần đợi đến sau khi hoàn tất các chuyến đi của mình"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b635200991 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn có thể xem chi tiết đặt phòng và được hỗ trợ, khi cần, với tài khoản của mình. Hãy thử lại sau khi chuyến đi kết thúc."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1106659683 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn có thể xem chi tiết đặt phòng và được hỗ trợ, khi cần, với tài khoản của mình. Vui lòng thử lại sau khi chuyến đi kết thúc."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2089503396 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc, bạn không thể xóa tài khoản vào lúc này"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2098842490 = messageFormatterFn((function(  ) {
  return function(d) { return "Tài khoản này cũng được dùng để quản lý nơi lưu trú trên Vrbo. Trước khi có thể xóa tài khoản, bạn cần đăng nhập bằng ứng dụng hoặc trang web Vrbo Owner để xóa tin bán phòng đang hoạt động của mình."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1331682153 = messageFormatterFn((function(  ) {
  return function(d) { return "Vui lòng cho chúng tôi biết lý do bạn rời đi."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1179770082 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi có tài khoản với một email khác"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1876718237 = messageFormatterFn((function(  ) {
  return function(d) { return "Tôi có trải nghiệm đặt phòng không tốt"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b551608456 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc vì bạn quyết định rời đi. Xin lưu ý rằng hành động xóa tài khoản là không thể đảo ngược và sẽ ảnh hưởng đến dữ liệu của bạn với Expedia, Hotels.com và Vrbo. Sau đây là một số thông tin bạn cần biết:"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2061866563 = messageFormatterFn((function(  ) {
  return function(d) { return "Rất tiếc vì bạn quyết định rời đi. Xin lưu ý rằng hành động xóa tài khoản là không thể đảo ngược và sẽ ảnh hưởng đến dữ liệu của bạn với Expedia, Wotif, Hotels.com và Vrbo. Sau đây là một số thông tin bạn cần biết:"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b684376508 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất lịch sử tài khoản, tùy chọn và các mục đã lưu trên Expedia, Hotels.com và Vrbo."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1394316273 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất lịch sử tài khoản, tùy chọn và các mục đã lưu trên Expedia, Wotif, Hotels.com và Vrbo."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b93185032 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất tất cả OneKeyCash, bao gồm cả OneKeyCash chờ nhận và bậc One Key cùng tất cả đặc quyền liên quan."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a996071662 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất tất cả OneKeyCash chờ nhận và bậc One Key cùng tất cả đặc quyền liên quan."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2029044029 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất OneKeyCash trị giá " + d["0"] + ", bao gồm OneKeyCash chờ nhận và bậc One Key cùng tất cả đặc quyền liên quan."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1743676487 = messageFormatterFn((function(  ) {
  return function(d) { return "Chủ thẻ tín dụng Hotels.com Rewards sẽ không tiếp tục nhận được phần thưởng dựa trên hoạt động của thẻ nữa."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1037009706 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất toàn bộ điểm Expedia Rewards, bao gồm tất cả điểm Expedia Rewards đã xác nhận và đang chờ nhận, tem Hotels.com Rewards, đêm thưởng và bậc thưởng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a334089932 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất tất cả điểm Expedia Rewards đang chờ nhận, cùng tem Hotels.com Rewards, đêm thưởng và bậc thưởng."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b581216494 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất tất cả coupon và khoản tín thác cho Expedia, Hotels.com hoặc Vrbo."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a626799197 = messageFormatterFn((function(  ) {
  return function(d) { return "Bạn sẽ vĩnh viễn mất tất cả coupon và khoản tín thác cho Expedia, Wotif, Hotels.com hoặc Vrbo."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1862746795 = messageFormatterFn((function(  ) {
  return function(d) { return "Có thể sẽ mất vài tuần để xử lý yêu cầu xóa tài khoản Expedia, Hotels.com và Vrbo của bạn. Vì vậy, bạn có thể tiếp tục nhận thông báo trong khi hệ thống của chúng tôi cập nhật."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b2134554826 = messageFormatterFn((function(  ) {
  return function(d) { return "Có thể sẽ mất vài tuần để xử lý yêu cầu xóa tài khoản Expedia, Wotif, Hotels.com và Vrbo của bạn. Vì vậy, bạn có thể tiếp tục nhận thông báo trong khi hệ thống của chúng tôi cập nhật."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a2013549024 = messageFormatterFn((function(  ) {
  return function(d) { return "Khi xóa tài khoản, One Key Card của bạn sẽ bị đóng và bạn sẽ không còn nhận được OneKeyCash cho bất kỳ khoản thanh toán nào nữa. Wells Fargo sẽ liên hệ với bạn để xác nhận việc đóng thẻ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1946510922 = messageFormatterFn((function(  ) {
  return function(d) { return "Khi xóa tài khoản, One Key+ Card của bạn sẽ bị đóng và bạn sẽ không còn nhận được OneKeyCash cho bất kỳ khoản thanh toán nào nữa. Wells Fargo sẽ liên hệ với bạn để xác nhận việc đóng thẻ."; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a423436577 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập hoặc tạo tài khoản để nhận OneKeyCash cho chuyến đi"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b113198119 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập hoặc tạo tài khoản để nhận thưởng cho kỳ lưu trú này"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.a1711980768 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanh toán với vai trò khách"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b793421394 = messageFormatterFn((function(  ) {
  return function(d) { return "Đăng nhập tài khoản " + d["0"] + ": Thêm số điện thoại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b1763287102 = messageFormatterFn((function(  ) {
  return function(d) { return "Đã có lỗi nào đó"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b964091580 = messageFormatterFn((function(  ) {
  return function(d) { return "Hãy thử đăng nhập lại"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b354068037 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("vi-VN").pluralGenerator({}));
Globalize.b39779 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1114586147 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a37815152 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1084638806 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1060445123 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b1508481678 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a737276893 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1006304099 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b476809827 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b203756240 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b1778865091 = dateToPartsFormatterFn({"2":Globalize("vi-VN").numberFormatter({"raw":"00"}),"4":Globalize("vi-VN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b352215646 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"CN","mon":"T2","tue":"T3","wed":"T4","thu":"T5","fri":"T6","sat":"T7"}}}});
Globalize.a1096986013 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Chủ Nhật","mon":"Thứ Hai","tue":"Thứ Ba","wed":"Thứ Tư","thu":"Thứ Năm","fri":"Thứ Sáu","sat":"Thứ Bảy"}}}});
Globalize.b156259427 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.b1387428253 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1867858896 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"}),"2":Globalize("vi-VN").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1098899697 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.b313208904 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.a937479677 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM, y","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.b939650685 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"MMMM 'năm' y","timeSeparator":":","months":{"M":{"4":{"1":"tháng 1","2":"tháng 2","3":"tháng 3","4":"tháng 4","5":"tháng 5","6":"tháng 6","7":"tháng 7","8":"tháng 8","9":"tháng 9","10":"tháng 10","11":"tháng 11","12":"tháng 12"}}}});
Globalize.b938965492 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"d MMM, y","timeSeparator":":","months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.a307632305 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Chủ Nhật","mon":"Thứ Hai","tue":"Thứ Ba","wed":"Thứ Tư","thu":"Thứ Năm","fri":"Thứ Sáu","sat":"Thứ Bảy"}}},"months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.b320597072 = dateToPartsFormatterFn({"1":Globalize("vi-VN").numberFormatter({"raw":"0"})}, {"pattern":"E, d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"CN","mon":"Th 2","tue":"Th 3","wed":"Th 4","thu":"Th 5","fri":"Th 6","sat":"Th 7"}}},"months":{"M":{"3":{"1":"thg 1","2":"thg 2","3":"thg 3","4":"thg 4","5":"thg 5","6":"thg 6","7":"thg 7","8":"thg 8","9":"thg 9","10":"thg 10","11":"thg 11","12":"thg 12"}}}});
Globalize.a378673972 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b735872396 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1852732359 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a730278401 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b681731372 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a306435529 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1115990644 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b627590348 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b98096076 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1611160967 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b1400151340 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b503389013 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a260825460 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b992419980 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b804144660 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"d"}));
Globalize.a1476451815 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1526758266 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a65504847 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b207295930 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b560936934 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b560251741 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b310098246 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a58116679 = dateFormatterFn(Globalize("vi-VN").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1992735715 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a878189347 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1063351350 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b59102608 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a932330371 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b482945480 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b1564914909 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a986471395 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a1515965667 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a821779958 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a213910403 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1302745756 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^CN/],["mon",/^T2/],["tue",/^T3/],["wed",/^T4/],["thu",/^T5/],["fri",/^T6/],["sat",/^T7/]]});
Globalize.b650743453 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^Chủ Nhật/],["mon",/^Thứ Hai/],["thu",/^Thứ Năm/],["fri",/^Thứ Sáu/],["sat",/^Thứ Bảy/],["tue",/^Thứ Ba/],["wed",/^Thứ Tư/]]});
Globalize.b1903988893 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.a1933035613 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1632054806 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1469216533 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
Globalize.a1679566590 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.b1710989449 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM, y","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.a1053124809 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM 'năm' y","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^tháng 10/],["11",/^tháng 11/],["12",/^tháng 12/],["1",/^tháng 1/],["2",/^tháng 2/],["3",/^tháng 3/],["4",/^tháng 4/],["5",/^tháng 5/],["6",/^tháng 6/],["7",/^tháng 7/],["8",/^tháng 8/],["9",/^tháng 9/]]});
Globalize.a1053810002 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM, y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
Globalize.a2044408747 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^Chủ Nhật/],["mon",/^Thứ Hai/],["thu",/^Thứ Năm/],["fri",/^Thứ Sáu/],["sat",/^Thứ Bảy/],["tue",/^Thứ Ba/],["wed",/^Thứ Tư/]],"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
Globalize.a1672178422 = dateParserFn(Globalize("vi-VN").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["mon",/^Th 2/],["tue",/^Th 3/],["wed",/^Th 4/],["thu",/^Th 5/],["fri",/^Th 6/],["sat",/^Th 7/],["sun",/^CN/]],"gregorian/months/format/abbreviated":[["10",/^thg 10/],["11",/^thg 11/],["12",/^thg 12/],["1",/^thg 1/],["2",/^thg 2/],["3",/^thg 3/],["4",/^thg 4/],["5",/^thg 5/],["6",/^thg 6/],["7",/^thg 7/],["8",/^thg 8/],["9",/^thg 9/]]});
module.exports = Globalize;
